// extracted by mini-css-extract-plugin
export default {"mainDiv":"editPlayerThank_mainDiv__V8gyK","subDiv":"editPlayerThank_subDiv__HE43m","buttonDefault":"editPlayerThank_buttonDefault__Cs9Av"};